export default __webpack_public_path__ + "static/media/currency.acff3497.svg";